module.exports = __webpack_public_path__ + "img/Flag_of_South_Africa.422a1e16.svg";